<template>
  <div class="bm-test">

  </div>
</template>

<script>
import { setTitle, callShare, enableShare, disableShare, enableMenuBar, sendPassport } from '@/libs/ds-bridge'
import { getLiveBroadcastPlan } from '@/api/pay'

export default {
  name: 'InsureList',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getLiveBroadcastPlan()
  },
  methods: {
    getLiveBroadcastPlan() {
      let params = {
        pricePlanId: 3
      }
      if (process.env.NODE_ENV !== 'production') {
        params.mockupCase = 1 // 假数据才用到的参数 真正上线后须去掉
      }
      getLiveBroadcastPlan(params).then(response => {
        // console.log(response)

      })
    },
    testSetTitle() {
      alert(111)
      setTitle('测试标题')
    },
    testCallShare() {
      callShare({title: '分享标题', desc: '分享描述', link: '分享URL', imgUrl: '分享logo'})
    },
    testEnableShare() {
      enableShare({title: '分享标题', desc: '分享描述', link: '分享URL', imgUrl: '分享logo'})
    },
    testDisableShare() {
      disableShare()
    },
    testEnableMenuBar() {
      enableMenuBar({report: {objId: 43922, objType: 'video'}})
    },
    testSendPassport() {
      sendPassport('7mm0gxhymlxty7egn7nkcjid4mkr0qho')
    },
    goHome() {
      this.$router.push({name: 'Home'})
    },
    reload() {
      location.reload()
    }
  }
}
</script>

<style lang="stylus">
.bm-test
  .gap
    margin 60px
</style>



// WEBPACK FOOTER //
// src/pages/home/test.vue